import type { PropsWithChildren } from 'react';

import React, { useContext } from 'react';

import ChatInterfaceComponent from '@Hub/Owlbot/Chat';

import { ProjectContext } from '@core/context';
import useClassy from '@core/hooks/useClassy';
import { useSuperHubStore } from '@core/store';
import { classy } from '@core/utils/classy';

import classes from './index.module.scss';

export default function ContentWithOwlbot({ children }: PropsWithChildren) {
  const bem = useClassy(classes, 'ContentWithOwlbot');
  const { project } = useContext(ProjectContext);

  const [isOwlbotOpen, isInSuperHubAdminView, toggleOwlbot] = useSuperHubStore(s => [
    s.isOwlbotOpen,
    s.user.role === 'admin' || s.user.role === 'editor', // SuperHub admin/editor views have taller header
    s.toggleOwlbot,
  ]);

  const showOwlbot = isOwlbotOpen && project?.owlbot?.enabled && project?.owlbot?.newExperience;

  return (
    <div className={bem('&', showOwlbot && '_with-sidebar', isInSuperHubAdminView && '_superhub')}>
      <div className={bem('-content')}>{children}</div>

      {!!(project?.owlbot?.enabled && project?.owlbot?.newExperience) && (
        <div className={classy(bem('-sidebar'), 'rm-AskAi-sidebar')}>
          {!!showOwlbot && <ChatInterfaceComponent onClose={toggleOwlbot} />}
        </div>
      )}
    </div>
  );
}
